var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allowCncSwitch)?_c('v-btn',{attrs:{"block":"","color":"blue darken-2","outlined":"","large":"","loading":_vm.loading},on:{"click":function($event){return _vm.switchCnc()}}},[_vm._v(_vm._s(_vm.switchText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }